<template>
  <div>
    <v-row align="center">
      <v-col cols="12" md="12" class="text-start">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("user.enrolledEmployees") }}
        </span>
      </v-col>

      <v-col cols="12" md="12">
        <EnrolledEmployeesFilters
          @filter="filterBy"
          :loading="loading"
          :showTrainer="true"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <registration-list
          :datas="registrationsData"
          :loading="loading"
          @reFetch="refetch"
        />
      </v-col>
      <v-col cols="12" v-if="registrationsData && registrationsData.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import RegistrationList from "../../user-module/components/RegistrationsList.vue";
import EnrolledEmployeesFilters from "./EnrolledEmployeesFilters.vue";
import Pagination from "../../core-module/components/Pagination.vue";
export default {
  components: {
    RegistrationList,
    EnrolledEmployeesFilters,
    Pagination,
  },
  data() {
    return {
      registrationsData: [],
      loading: true,
      variables: {
        limit: 10,
        skip: 0,
      },
      filterInputs: {},
      totalCount: null,
      totalPages: 0,
    };
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: this.variablesDefaultValue(),
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.registrationsData =
              data.getTrainingRegistrations.trainingRegistrations;
            this.totalCount = data.getTrainingRegistrations.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }

          this.loading = loading;
        },
      };
    },
  },
  created() {
    this.$apollo.queries.getTrainingRegistrations.refetch();
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    filterBy(key, value) {
      if (key === "organization") {
        if (!value) {
          delete this.filterInputs?.organization;
        } else {
          this.filterInputs.organization = value;
        }
      }

      if (key === "trainer") {
        if (!value) {
          delete this.filterInputs?.trainer;
        } else {
          this.filterInputs.trainer = value;
        }
      }

      if (key === "category") {
        if (!value) {
          delete this.filterInputs?.trainingCategory;
        } else {
          this.filterInputs.trainingCategory = value;
        }
      }

      if (key === "training") {
        if (!value) {
          delete this.filterInputs?.training;
        } else {
          this.filterInputs.training = value;
        }
      }

      this.variables.limit = 10;
      this.variables.skip = 0;
      this.refetch();
    },
    async refetch() {
      this.loading = true;
      this.$apollo.queries.getTrainingRegistrations.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: this.filterInputs,
      });
    },
  },
};
</script>
